export default __webpack_public_path__ + "static/media/logout.49619207.svg";